import { useDisclosure } from '@cardboard-ui/react';
import React from 'react';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { t } from '@lingui/macro';
import { SettingsWheelIcon } from 'components/icons';
import AccessModal from 'components/AccessModal';
import { graphql, useFragment } from 'utils/graphClient';
import { AccessOption_node$key } from './__generated__/AccessOption_node.graphql';

const nodeFragment = graphql`
  fragment AccessOption_node on Node {
    id
    ... on Event {
      implementsPermissions: __typename
    }
    ... on FolderItem {
      implementsPermissions: __typename
    }
    ... on Folder {
      implementsPermissions: __typename
    }
    ... on Announcement {
      implementsPermissions: __typename
    }
    ... on VaultItem {
      isVaultItem: __typename
      canSeeVaultItemPermissions: canDelete {
        value
      }
    }
    ... on Vault {
      isVault: __typename
    }
  }
`;

interface AccessOptionProps {
  node: AccessOption_node$key;
}

export const AccessOption = (props: AccessOptionProps) => {
  const {
    id,
    implementsPermissions,
    isVaultItem,
    canSeeVaultItemPermissions,
    isVault,
  } = useFragment(nodeFragment, props.node);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const supportsAccess =
    implementsPermissions ||
    (isVaultItem && canSeeVaultItemPermissions?.value) ||
    isVault;

  if (!supportsAccess) {
    return null;
  }

  return (
    <>
      <OptionsMenuItem
        icon={<SettingsWheelIcon />}
        onClick={onOpen}
      >{t`Access`}</OptionsMenuItem>
      <AccessModal isOpen={isOpen} onClose={onClose} nodeId={id} />
    </>
  );
};
